// <!-- ============================================================================= -->
// <!-- Ella Custom JS - Customize The Style For Layout -->
// <!-- ============================================================================= -->

// <!-- ============================================================================= -->
// <!-- IMPORTANT DISCLAIMER -->
// <!-- Please use only JS to style the layout. -->
// <!-- ============================================================================= -->

$(document).ready(function () {
	// Manipulate footer
	let footerCol1 = $(
		".footer-1 .footer__content-top .halo-row .footer-block__item:nth-of-type(2)"
	);
	let footerCol2 = $(
		".footer-1 .footer__content-top .halo-row .footer-block__item:nth-of-type(3)"
	);
	let footerCol3 = $(
		".footer-1 .footer__content-top .halo-row .footer-block__item:nth-of-type(4)"
	);

	function handleTopMarginStack() {
		if (window.matchMedia("(max-width:680px)").matches) {
			const footerCol1Height = footerCol1.height();
			const footerCol2Height = footerCol2.height();
			const gapBetweenCol1andCol3 =
				footerCol2Height - (footerCol1Height + 35);
			footerCol3.css("margin-top", "-" + gapBetweenCol1andCol3 + "px");
		} else {
			footerCol3.css("margin-top", "");
		}
	}

	handleTopMarginStack();

	$(window).resize(function () {
		handleTopMarginStack();
	});

	const fancyVariantSwatch = document.querySelectorAll(
		"[data-fancy-variant-swatch]"
	);

	// const pdpFancybox = Fancybox.getInstance();

	fancyVariantSwatch.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			const gid = trigger.dataset.fancyVariantSwatch;
			const targetId = trigger.dataset.target;
			const targetElm = document.getElementById(targetId);
			const triggerElm = document.getElementById(`trigger-${gid}`);
			targetElm.click();

			document.querySelector(".fancy-variant-swatch--item.fvs-active").classList.remove('fvs-active');
			trigger.classList.add('fvs-active');

			setTimeout(() => {
				$.fancybox.getInstance('close');
				triggerElm.click();
			}, 50);
		});
	});
});
